import { NAMED_GRAPH_LIMIT } from 'src/constants/limits';

export type NamedGraphBinding = {
  graph: {
    type: 'uri';
    value: string;
  };
  isAlias: {
    type: 'http://www.w3.org/2001/XMLSchema#boolean';
    value: string;
  };
  isVirtual: {
    type: 'http://www.w3.org/2001/XMLSchema#boolean';
    value: string;
  };
};

/**
 * Determines the available named graphs and named graph aliases for a given database.
 *
 * Populates the Named Graph selector in the Settings dialog.
 *
 * **Call Frequency**
 *
 * This query is called for each database whenever the current connection changes.
 *
 * **Context**
 * - Named graphs: always the default named graph (none specified)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
# Named Graphs ( graph + aliases )
#pragma plan.cache off
SELECT DISTINCT
  ?graph
  (max(?isAliasGraph) as ?isAlias)
  (max(?isVirtualGraph) as ?isVirtual)
FROM NAMED <tag:stardog:api:context:all>
WHERE {
  {
    GRAPH ?graph { }
    FILTER ( ?graph NOT IN ( <tag:stardog:api:graph:aliases>, <tag:stardog:api:sql:schema> ) )
    BIND(false as ?isAliasGraph)
    BIND(STRSTARTS(STR(?graph), 'virtual://') as ?isVirtualGraph)
  } UNION {
    GRAPH <tag:stardog:api:graph:aliases> {
      ?graph <tag:stardog:api:graph:alias> ?original
    }
    BIND(true as ?isAliasGraph)
    BIND(STRSTARTS(STR(?original), 'virtual://') as ?isVirtualGraph)
  }
}
GROUP BY ?graph
LIMIT
 * ```
 */

// TODO: #pragma plan.cache off should no longer be necessary after PLAT-6627 is
// fixed
export const getNamedGraphs = `# Named Graphs ( graph + aliases )
#pragma plan.cache off
SELECT DISTINCT
  ?graph
  (max(?isAliasGraph) as ?isAlias)
  (max(?isVirtualGraph) as ?isVirtual)
FROM NAMED <tag:stardog:api:context:all>
WHERE {
  {
    GRAPH ?graph { }
    FILTER ( ?graph NOT IN ( <tag:stardog:api:graph:aliases>, <tag:stardog:api:sql:schema> ) )
    BIND(false as ?isAliasGraph)
    BIND(STRSTARTS(STR(?graph), 'virtual://') as ?isVirtualGraph)
  } UNION {
    GRAPH <tag:stardog:api:graph:aliases> {
      ?graph <tag:stardog:api:graph:alias> ?original
    }
    BIND(true as ?isAliasGraph)
    BIND(STRSTARTS(STR(?original), 'virtual://') as ?isVirtualGraph)
  }
}
GROUP BY ?graph
LIMIT ${NAMED_GRAPH_LIMIT}
`;
